export enum SalesFileType {
  target = 'Target',
  sales = 'Sales',
  pharmacy = 'Pharmacy',
  userTarget = 'UserTarget',
}
